<!--
    此组件用于简单的轮播图，目前只针对新闻列表每屏3个做了适配
    如果需要更多的自定义，可以自行修改
-->
<template>
  <div class="simple-swiper">
    <swiper :options="swiperOptions" ref="simpleSwiper" v-if="dataList.length">
      <swiper-slide
        v-for="(slide, index) in dataList"
        :key="index"
        :data-index="index"
        class="slide-item"
      >
        <slot name="slide" :item="slide">
          <!-- Default slot content -->
          <img
            class="slide-pic"
            :src="$urlImg(slide.coverUrl)"
            :alt="slide.title"
          />
          <!-- <div class="slide-title">
            <div class="slide-text">{{ slide.title }}</div>
          </div> -->
        </slot>
      </swiper-slide>
    </swiper>
    <div
      :class="['swiper-button-next', `swiper-button-next-${swiperId}`]"
      slot="button-next"
      v-if="navigation"
    ></div>
    <div
      :class="['swiper-button-prev', `swiper-button-prev-${swiperId}`]"
      slot="button-prev"
      v-if="navigation"
    ></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import 'swiper/dist/css/swiper.css'
import "swiper/css/swiper.css";
// import 'swiper/css/navigation'

import { setupLazyImage } from '@/utils/lazyImage'

export default {
  name: "SimpleSwiper",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    baseSpaceBetween: {
      type: Number,
      default: 0
    },
    slidesPerView: {
      type: Number,
      default: 1
    },
    adaptiveSpaceBetween: {
      type: Boolean,
      default: true
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    autoplayDelay: {
      type: Number,
      default: 3000
    },
    navigation: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      swiperId: `swiper-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      swiperOptions: null
    };
  },

  computed: {
    dynamicSpaceBetween() {
      if (!this.adaptiveSpaceBetween) return this.baseSpaceBetween;
      return Math.floor((this.windowWidth / 1920) * this.baseSpaceBetween);
    }
  },

  created() {
    this.initSwiperOptions();
  },

  mounted() {
    if (this.adaptiveSpaceBetween) {
      window.addEventListener('resize', this.handleResize);
    }
  },

  beforeDestroy() {
    if (this.adaptiveSpaceBetween) {
      window.removeEventListener('resize', this.handleResize);
    }
  },

  methods: {
    initSwiperOptions() {
      const _swiperOptions = {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          init: () => {
            this.$nextTick(this.handleResize);
            this.$nextTick(() => {
              this.handleLazyImgFix(this.$refs.simpleSwiper.$swiper);
            });
          },
          afterInit: () => {
            // console.log(`afterInit`)
            // console.log(this.$refs.simpleSwiper.$swiper.slides.length)
          },
          beforeLoopFix: () => {
            // console.log('beforLoopFix')
            // console.log(this.$refs.simpleSwiper.$swiper.slides)
          },
          loopFix: () => {
            // this.handleLazyImgFix(this.$refs.simpleSwiper.$swiper)
            // console.log('loopFix')
            // console.log(this.$refs.simpleSwiper.$swiper.slides.length)
          },
          click: (swiper, _) => {
            // 获取当前点击的幻灯片元素
            const clickedEl = swiper.target.closest('.swiper-slide');
            if (clickedEl) {
              const index = parseInt(clickedEl.getAttribute('data-swiper-slide-index') || clickedEl.getAttribute('data-index'));
              if (!isNaN(index) && this.dataList[index]) {
                this.handleClick(this.dataList[index]);
              }
            }
          }
        }
      };

      // 每屏显示的数量
      if (this.slidesPerView) {
        _swiperOptions.slidesPerView = this.slidesPerView;
      }

      // 根据页面宽度自动计算间距
      if (this.adaptiveSpaceBetween && this.baseSpaceBetween) {
        _swiperOptions.spaceBetween = this.dynamicSpaceBetween;
      } else {
        _swiperOptions.spaceBetween = this.baseSpaceBetween;
      }

      // 自动播放
      if (this.autoplay) {
        _swiperOptions.autoplay = {
          delay: this.autoplayDelay, // 时间间隔
          disableOnInteraction: false // 操作后是否停止自动播放
        };
      }

      if (this.navigation) {
        _swiperOptions.navigation = {
          nextEl: `.swiper-button-next-${this.swiperId}`,
          prevEl: `.swiper-button-prev-${this.swiperId}`
        };
      }

      if (this.loop) {
        _swiperOptions.loop = true
      } else {
        _swiperOptions.loop = false
      }

      this.swiperOptions = _swiperOptions;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      if (this.$refs.simpleSwiper && this.$refs.simpleSwiper.$swiper) {
        if (this.adaptiveSpaceBetween) {
          this.swiperOptions.spaceBetween = this.dynamicSpaceBetween;
          this.$refs.simpleSwiper.$swiper.params.spaceBetween = this.dynamicSpaceBetween;
        }
        this.$refs.simpleSwiper.$swiper.update();
      }
    },
    handleLazyImgFix(swiper) {
      const slides = swiper.slides;

      // 找到所有swiper复制出来的slide元素，这些元素具有 class "swiper-slide-duplicate"
      const duplicateSlides = Array.from(slides).filter((slide) =>
        slide.classList.contains("swiper-slide-duplicate")
      );
      duplicateSlides.forEach((slide) => {
        // 查找所有未初始化的 lazy 图片（包括克隆出来的 DOM）
        const lazyImages = slide.querySelectorAll(
          "img.lazy-img:not([data-lazy-bound])"
        );
        lazyImages.forEach((img) => {
          // 手动加载图片
          setupLazyImage(img, () => {
            // 从 data-src 获取真实图片地址，然后赋值给 src
            const realSrc = img.getAttribute("data-src");
            if (realSrc) {
              img.src = realSrc;
              // 给img元素增加属性 lazy-img--loaded
              img.classList.add("lazy-img--loaded");
            }
            // 如果需要，还可以手动触发 load 事件
            // img.dispatchEvent(new Event("load"));
          });
        });
      });
    },
    handleClick(item) {
      this.$emit('slide-click', item);
    }
  }
};
</script>

<style scoped lang="scss">
.simple-swiper {
  width: 100%;
  position: relative;
  overflow: hidden;

  --nav-btn-height: 36px;
}

.slide-item {
  cursor: pointer;
  width: 888px !important;
  background: #fff;
}

.slide-pic {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.slide-title {
  margin-top: 10px;
}

.slide-text {
  font-size: 16px;
  line-height: 1.4;
}

.swiper-button-next {
  width: var(--nav-btn-height);
  height: var(--nav-btn-height);
  //  top: calc(50% - var(--nav-btn-height) / 2);
  top: 50%;
  background-image: url("../assets/image/home/right.png");
  background-size: 100%;
  transition: all 0.3s ease;
  right: 400px;
  &:after {
    content: "";
  }

  &:hover {
    transform: scale(1.5);
  }
}
.swiper-button-prev {
  width: var(--nav-btn-height);
  height: var(--nav-btn-height);
  //  top: calc(50% - var(--nav-btn-height) / 2);
  top: 50%;
  background-image: url("../assets/image/home/left.png");
  background-size: 100%;
  transition: all 0.3s ease;
  left: 400px;

  &:after {
    content: "";
  }

  &:hover {
    transform: scale(1.5);
  }
}
</style>
